import React, { Component, useState, useEffect } from 'react';
import * as ReactDOM from 'react-dom';
import Configdata from './Defaultdata';
import Usersession from './Usersession';
import mvilla from './imgs/mordenvilla.jpeg';
import hvilla from './imgs/hospital.jpeg';
import eduvilla from './imgs/education.jpeg';
import scivlla from './imgs/sciencelab.jpeg';
import village from './imgs/villagevilla.jpeg';
import grden from './imgs/garden.jpeg';
import cultural from './imgs/cultural.jpeg';
import {cleardv} from './clearmem';
import {Useraction} from './Useractions';
import axios from 'axios';
import {clrwidgate,insertpost,getcolval,getcolnotval} from './userdefaultdata';
import {Friends} from './Usrfriends';
export default class UFriends extends Component {

    constructor(props: any) {
   	super(props);
	this.state.name = "villa";
	
  	}
	
    state = {

	
        name: "villa",
       respdata: null,   
       url: "",
      vnm:"villa",
      imgurl:mvilla,	
    };
    setserverurl() {
        debugger;
        const appurl = Configdata.srvurl;
       
        this.setState({ url: appurl });
    }
    componentDidMount() {
        debugger;
        const tuserid = Usersession.getUserId();
       
	this.getfriendrqsts(tuserid,true);
	
    }
  reducearray(arr: any,opt:any){
     let farr = [{}];
     let ucode = "";	
     const tuserid = Usersession.getUserId();
      
	
      if(arr){
	     if(arr.length > 0){
		for(let i =0;i< arr.length;i++){
                
                 const rv = arr[i][0];
		 
		 farr.push(rv);
		 
		}
	    }
	 }
	if(farr.length > 1){
	 farr.shift();
	}
	
	if(farr.length > 0){
        const dv = document.getElementById('frndrsdiv') as HTMLElement;
	//alert(JSON.stringify(farr));
	if(opt){
	const inboxdata = getcolval(farr,'msndruserid',tuserid);
      
        const frn = Friends(inboxdata,opt);
        ReactDOM.render(frn,dv);

	}
        else{
         
	  	
	  const inboxdata = getcolnotval(farr,'msndruserid',tuserid);
          
          const frn = Friends(inboxdata,opt);
	  ReactDOM.render(frn,dv);

	}
	
	}
	
      }	

 getfriendrqsts(eid:any,opt:any){
	 try {
        
          const url = "/getfriendrqst?prd=" + eid;
	//alert(url);	
	axios.get(Configdata.srvurl + url)
            .then((response: any) => {
               
		const tdata = response.data;
             
		this.reducearray(tdata,opt);
            })
            .catch((err: any) => {
             //   alert('Something went wrong');
                
            });

                
          }
        catch (e) {
            debugger;

        }

	
      	//e.preventDefault()


     }	
 
Requests(e:any,opt:any){
 const tuserid = Usersession.getUserId();
 this.getfriendrqsts(tuserid,opt);
 e.preventDefault();

}
 render() {
   
     return (

        
	<div id="friends">
         
	 <div id= "friendsdiv" className="c-txtarea">
           <div className="pr100">  
	      <div style={{width:'48%',float:'left'}}>
	        <a href="#" className="blanka"  onClick={e=>this.Requests(e,true)} title="Friend Request">
		<div id="frndrqst" style={{width:'100%'}} className="p-usr-frnd-cst">

		  	   Send Request 

             	</div>
	     </a>
	     </div>
              <div style={{width:'48%',float:'right'}}>
	        <a href="#" className="blanka"  onClick={e=>this.Requests(e,false)} title="Friend Request">
		<div id="frndrqst" style={{width:'100%'}} className="p-usr-frnd-cst">

		  	   Received 

             	</div>
	     </a>
	     </div>	
	
            </div> 
	   
	  </div>
 <div style={{height:'80vh',overflowY:'auto',position:'relative',width:'100vw'}} className="pr100"> 

		<div id="frndrsdiv" style={{height:'80vh',overflowY:'auto'}} className="pr100"> 


	        </div> 	

	    </div> 	
	</div>
   	
    
   
      );
}
}

